"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactAddonsPureRenderMixin = _interopRequireDefault(require("react-addons-pure-render-mixin"));

var _reactRedux = require("react-redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _classnames = _interopRequireDefault(require("classnames"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _compose = _interopRequireDefault(require("transmute/compose"));

var _immutable = require("immutable");

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H3"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _color = require("MeetingsBase/utils/color");

var _DatePickerButton = _interopRequireDefault(require("MeetingsLib/components/schedule/date/DatePickerButton"));

var _ZeroState = _interopRequireDefault(require("MeetingsLib/components/schedule/ZeroState"));

var _BookInfoSelectors = require("MeetingsLib/selectors/BookInfoSelectors");

var _AvailabilitySelectors = require("MeetingsLib/selectors/AvailabilitySelectors");

var _RequestStatusSelectors = require("MeetingsLib/selectors/RequestStatusSelectors");

var _RESTParamSelectors = require("MeetingsLib/selectors/RESTParamSelectors");

var _TroubleshootingSelectors = require("MeetingsLib/selectors/TroubleshootingSelectors");

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _UserProfile = _interopRequireDefault(require("MeetingsBase/models/UserProfile"));

var _EnsureAvailableDate = _interopRequireDefault(require("MeetingsLib/components/schedule/date/EnsureAvailableDate"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _HiddenAriaStatus = require("MeetingsLib/components/decorative/HiddenAriaStatus");

var StyledTable = _styledComponents.default.table.withConfig({
  displayName: "DatePicker__StyledTable",
  componentId: "g3gwqm-0"
})(["table-layout:fixed;width:100%;"]);

var StyledCaption = _styledComponents.default.caption.withConfig({
  displayName: "DatePicker__StyledCaption",
  componentId: "g3gwqm-1"
})(["font-size:0;line-height:0;"]);

var StyledSkipNav = _styledComponents.default.a.withConfig({
  displayName: "DatePicker__StyledSkipNav",
  componentId: "g3gwqm-2"
})(["position:absolute;left:-10000px;top:auto;width:1px;height:1px;overflow:hidden;"]);

var NUM_DAYS = 7;
var NUM_WEEKS = 5;
var DAY_RANGE = (0, _immutable.Range)().take(NUM_DAYS).toArray();
var DatePicker = (0, _createReactClass.default)({
  displayName: "DatePicker",
  propTypes: {
    // passed
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired,
    compact: _propTypes.default.bool,
    profile: _propTypes.default.instanceOf(_UserProfile.default),
    setEventDate: _propTypes.default.func.isRequired,
    DatePickerMarker: _propTypes.default.func.isRequired,
    TimePickerMarker: _propTypes.default.func.isRequired,
    // loaded
    bookableDates: _propTypes.default.instanceOf(_immutable.List).isRequired,
    configuredAvailabilityByDate: _propTypes.default.instanceOf(_immutable.OrderedMap).isRequired,
    availableDateOptions: _propTypes.default.instanceOf(_immutable.Seq).isRequired,
    editLinkURL: _propTypes.default.string.isRequired,
    troubleshootTimesForSelectedDurationByDay: _propTypes.default.instanceOf(_immutable.OrderedMap).isRequired,
    minimumNoticeTimeBusyDays: _propTypes.default.instanceOf(_immutable.List).isRequired,
    currentTime: _propTypes.default.number.isRequired,
    isFetchingPublicAvailability: _propTypes.default.bool.isRequired,
    userTimezone: _propTypes.default.string.isRequired,
    isTroubleshooting: _propTypes.default.bool.isRequired,
    selectedDate: _propTypes.default.string
  },
  mixins: [_reactAddonsPureRenderMixin.default],
  getInitialState: function getInitialState() {
    return {
      monthsAhead: 0
    };
  },
  getHeaderClasses: function getHeaderClasses() {
    var compact = this.props.compact;
    return (0, _classnames.default)('date-picker-header', {
      'm-bottom-4': compact,
      'm-bottom-6': !compact
    });
  },
  getMinimumAvailableDay: function getMinimumAvailableDay() {
    var availableDateOptions = this.props.availableDateOptions;
    return _I18n.default.moment(availableDateOptions.min());
  },
  getMaximumAvailableDay: function getMaximumAvailableDay() {
    var availableDateOptions = this.props.availableDateOptions;
    return _I18n.default.moment(availableDateOptions.max());
  },
  getStartOfMonth: function getStartOfMonth() {
    var availableDateOptions = this.props.availableDateOptions;
    var monthsAhead = this.state.monthsAhead;
    return _I18n.default.moment(availableDateOptions.min()).startOf('month').add(monthsAhead, 'months');
  },
  getEndOfMonth: function getEndOfMonth() {
    var availableDateOptions = this.props.availableDateOptions;
    var monthsAhead = this.state.monthsAhead;
    return _I18n.default.moment(availableDateOptions.min()).endOf('month').add(monthsAhead, 'months');
  },
  getDaysToShiftForward: function getDaysToShiftForward() {
    // some locales start their week on Monday
    return this.getLocaleData()._week.dow;
  },
  getDaysToShiftBack: function getDaysToShiftBack(dateObject) {
    var daysFromSunday = dateObject.isoWeekday() % 7;
    var daysToShiftForward = this.getDaysToShiftForward();
    /*
     * if the month starts on Sunday and we are in a locale
     * that starts weeks on Monday, we would cut off the first
     * Sunday unless we rendered the entire previous week
     */

    if (daysFromSunday === 0 && daysToShiftForward === 1) {
      return 6;
    }

    return daysFromSunday - daysToShiftForward;
  },
  getStartOfWeek: function getStartOfWeek(dateObject) {
    var daysToShiftBack = this.getDaysToShiftBack(dateObject);
    return dateObject.subtract(daysToShiftBack, 'days');
  },
  getLastDisplayedDay: function getLastDisplayedDay() {
    var startOfWeek = this.getStartOfWeek(this.getStartOfMonth());
    return _I18n.default.moment(startOfWeek).add({
      days: NUM_DAYS - 1,
      weeks: NUM_WEEKS - 1
    });
  },
  minOrMaxAvailabilityNotDisplayed: function minOrMaxAvailabilityNotDisplayed() {
    var lastDisplayedDay = this.getLastDisplayedDay();
    var lastDayOfMonth = this.getEndOfMonth();
    var minAvailableDay = this.getMinimumAvailableDay();
    var maxAvailableDay = this.getMaximumAvailableDay();
    var availabilityOutsideOfDisplayed = lastDisplayedDay.isBefore(minAvailableDay) || lastDisplayedDay.isBefore(maxAvailableDay);
    return lastDisplayedDay.isBefore(lastDayOfMonth) && availabilityOutsideOfDisplayed;
  },
  getMonthButtonOpacity: function getMonthButtonOpacity(disabled) {
    return disabled ? '0.5' : 1;
  },
  isMinMonth: function isMinMonth() {
    var availableDateOptions = this.props.availableDateOptions;
    return _I18n.default.moment(availableDateOptions.min()).month() === this.getStartOfMonth().month();
  },
  isMaxMonth: function isMaxMonth() {
    var availableDateOptions = this.props.availableDateOptions;
    return _I18n.default.moment(availableDateOptions.max()).month() === this.getStartOfMonth().month();
  },
  handleSetEventDate: function handleSetEventDate(date) {
    var _this$props = this.props,
        setEventDate = _this$props.setEventDate,
        availableDateOptions = _this$props.availableDateOptions,
        isTroubleshooting = _this$props.isTroubleshooting;

    if (isTroubleshooting || availableDateOptions.includes(date)) {
      setEventDate(date);
    }
  },
  getPrevMonth: function getPrevMonth() {
    this.setState({
      monthsAhead: this.state.monthsAhead - 1
    });
  },
  getNextMonth: function getNextMonth() {
    this.setState({
      monthsAhead: this.state.monthsAhead + 1
    });
  },
  getLocaleData: function getLocaleData() {
    return _I18n.default.moment.localeData(_I18n.default.locale) || _I18n.default.moment.localeData();
  },
  getAbbreviatedWeekdays: function getAbbreviatedWeekdays() {
    return new _immutable.List(this.getLocaleData()._weekdaysShort);
  },
  getWeekDayNames: function getWeekDayNames() {
    var numDaysToShift = this.getDaysToShiftForward();
    var daysOfWeek = this.getAbbreviatedWeekdays();
    var daysToShift = daysOfWeek.take(numDaysToShift);
    return daysOfWeek.splice(0, numDaysToShift).concat(daysToShift);
  },
  getWeekRange: function getWeekRange(extraWeek) {
    var weeksToRender = extraWeek ? NUM_WEEKS + 1 : NUM_WEEKS;
    return (0, _immutable.Range)().take(weeksToRender).toArray();
  },
  renderDays: function renderDays(weekNumber) {
    var _this = this;

    var _this$props2 = this.props,
        bookableDates = _this$props2.bookableDates,
        branding = _this$props2.branding,
        configuredAvailabilityByDate = _this$props2.configuredAvailabilityByDate,
        currentTime = _this$props2.currentTime,
        editLinkURL = _this$props2.editLinkURL,
        availableDateOptions = _this$props2.availableDateOptions,
        troubleshootTimesForSelectedDurationByDay = _this$props2.troubleshootTimesForSelectedDurationByDay,
        minimumNoticeTimeBusyDays = _this$props2.minimumNoticeTimeBusyDays,
        isTroubleshooting = _this$props2.isTroubleshooting,
        userTimezone = _this$props2.userTimezone;
    var startOfWeek = this.getStartOfWeek(this.getStartOfMonth());
    return DAY_RANGE.map(function (daysToAdd) {
      var date = _I18n.default.moment(startOfWeek).add({
        days: daysToAdd,
        weeks: weekNumber
      }).format('YYYY-MM-DD');

      return _react.default.createElement(_DatePickerButton.default, {
        key: date + "-" + daysToAdd,
        daysToAdd: daysToAdd,
        branding: branding,
        currentTime: currentTime,
        date: date,
        availableDates: availableDateOptions,
        handleSetEventDate: _this.handleSetEventDate // troubleshoot mode
        ,
        bookableDates: bookableDates,
        configuredAvailabilityByDate: configuredAvailabilityByDate,
        editLinkURL: editLinkURL,
        troubleshootTimesForSelectedDurationByDay: troubleshootTimesForSelectedDurationByDay,
        minimumNoticeTimeBusyDays: minimumNoticeTimeBusyDays,
        isTroubleshooting: isTroubleshooting,
        userTimezone: userTimezone
      });
    });
  },
  renderWeekDayNames: function renderWeekDayNames() {
    var weekDayNames = this.getWeekDayNames();
    return weekDayNames.map(function (dayName) {
      return _react.default.createElement("th", {
        scope: "col",
        key: dayName
      }, _react.default.createElement("span", {
        className: "is--heading-6"
      }, dayName));
    });
  },
  renderWeeksOrEmpty: function renderWeeksOrEmpty() {
    var _this$props3 = this.props,
        compact = _this$props3.compact,
        availableDateOptions = _this$props3.availableDateOptions,
        profile = _this$props3.profile,
        branding = _this$props3.branding,
        isFetchingPublicAvailability = _this$props3.isFetchingPublicAvailability,
        TimePickerMarker = _this$props3.TimePickerMarker;

    if (compact && !availableDateOptions.count() && !isFetchingPublicAvailability) {
      // Render empty state for compact view
      return _react.default.createElement("div", {
        className: "align-center m-top-12"
      }, _react.default.createElement(_ZeroState.default, {
        profile: profile,
        linkUse: (0, _color.getLinkUse)(branding.primaryColor),
        TimePickerMarker: TimePickerMarker
      }));
    }

    var currentMonth = this.getStartOfMonth().format('MMMM');
    var weekDaysClasses = (0, _classnames.default)('title-case', {
      'm-bottom-4': !compact,
      'm-bottom-2': compact
    });
    return _react.default.createElement(StyledTable, null, _react.default.createElement(StyledCaption, null, _react.default.createElement(_FormattedMessage.default, {
      message: "prebook.datePicker.caption",
      options: {
        currentMonth: currentMonth
      }
    })), _react.default.createElement("thead", null, _react.default.createElement("tr", {
      className: weekDaysClasses
    }, this.renderWeekDayNames())), _react.default.createElement("tbody", null, this.renderWeeks()));
  },
  renderWeeks: function renderWeeks() {
    var _this2 = this;

    var extraWeek = this.minOrMaxAvailabilityNotDisplayed();
    return this.getWeekRange(extraWeek).map(function (weeksToAdd) {
      return _react.default.createElement("tr", {
        key: weeksToAdd,
        className: "extraWeek"
      }, _this2.renderDays(weeksToAdd));
    });
  },
  renderHeader: function renderHeader() {
    var primaryColor = this.props.branding.primaryColor;
    var isMinMonth = this.isMinMonth();
    var isMaxMonth = this.isMaxMonth();
    var monthBackOpacity = this.getMonthButtonOpacity(isMinMonth);
    var monthForwardOpacity = this.getMonthButtonOpacity(isMaxMonth);
    var textColor = (0, _color.getTextColor)(primaryColor);
    var currentMonthName = this.getStartOfMonth().format('MMMM');
    var previousMonthName = this.getStartOfMonth().add(-1, 'months').format('MMMM');
    var nextMonthName = this.getStartOfMonth().add(1, 'months').format('MMMM');
    return _react.default.createElement(_UIFlex.default, {
      align: "center",
      justify: "around",
      className: this.getHeaderClasses()
    }, _react.default.createElement(_UITooltip.default, {
      title: _react.default.createElement(_FormattedMessage.default, {
        message: "prebook.datePicker.noPreviousMonthReason",
        options: {
          month: previousMonthName
        }
      }),
      disabled: !isMinMonth,
      placement: 'right'
    }, _react.default.createElement(_UIButton.default, {
      use: "transparent",
      onClick: this.getPrevMonth,
      disabled: isMinMonth,
      "aria-label": _I18n.default.text('prebook.datePicker.previousMonth', {
        month: previousMonthName
      })
    }, _react.default.createElement(_UIIcon.default, {
      name: "left",
      color: textColor,
      style: {
        opacity: monthBackOpacity
      }
    }))), _react.default.createElement(_H.default, {
      "aria-label": currentMonthName,
      "aria-level": 2,
      className: "m-bottom-0",
      style: {
        minWidth: '80px'
      }
    }, currentMonthName), _react.default.createElement(_UITooltip.default, {
      title: _react.default.createElement(_FormattedMessage.default, {
        message: "prebook.datePicker.noNextMonthReason",
        options: {
          month: nextMonthName
        }
      }),
      disabled: !isMaxMonth,
      placement: 'left'
    }, _react.default.createElement(_UIButton.default, {
      use: "transparent",
      onClick: this.getNextMonth,
      disabled: isMaxMonth,
      "aria-label": _I18n.default.text('prebook.datePicker.nextMonth', {
        month: nextMonthName
      }),
      "data-selenium-test": "next-month-button"
    }, _react.default.createElement(_UIIcon.default, {
      name: "right",
      color: textColor,
      style: {
        opacity: monthForwardOpacity
      }
    }))));
  },
  render: function render() {
    var _this$props4 = this.props,
        DatePickerMarker = _this$props4.DatePickerMarker,
        selectedDate = _this$props4.selectedDate;

    var localizedDate = _I18n.default.moment(selectedDate).format('MMMM Do');

    return _react.default.createElement("div", {
      className: "date-picker"
    }, this.renderHeader(), _react.default.createElement(StyledSkipNav, {
      onClick: function onClick() {
        document.getElementById('selected-date').focus();
      }
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "prebook.datePicker.skipToAvailableDate",
      options: {
        monthDay: localizedDate
      }
    })), this.renderWeeksOrEmpty(), _react.default.createElement(DatePickerMarker, null), _react.default.createElement(_HiddenAriaStatus.HiddenAriaStatus, {
      className: "calendar-status",
      role: "status",
      "aria-live": "polite"
    }, _react.default.createElement(_FormattedMessage.default, {
      message: "accessible.calendarStatus",
      options: {
        selectedDate: localizedDate
      }
    })));
  }
});

var _default = (0, _compose.default)((0, _reactRedux.connect)(function (state) {
  return {
    // Rerenders component in response to translation
    activeLocale: state.activeLocale,
    bookableDates: (0, _TroubleshootingSelectors.getConfiguredBookableDates)(state),
    configuredAvailabilityByDate: (0, _TroubleshootingSelectors.getConfiguredAvailabilityByDate)(state),
    currentTime: (0, _RESTParamSelectors.getCurrentTime)(state),
    availableDateOptions: (0, _AvailabilitySelectors.getAvailableDates)(state),
    editLinkURL: (0, _BookInfoSelectors.getEditLinkURL)(state),
    troubleshootTimesForSelectedDurationByDay: (0, _TroubleshootingSelectors.getTroubleshootTimesForSelectedDurationByDay)(state),
    isFetchingPublicAvailability: (0, _RequestStatusSelectors.getIsFetchingPublicAvailability)(state),
    isFetchingPublicOwnerAvailability: (0, _RequestStatusSelectors.getIsFetchingOwnerPublicAvailability)(state),
    minimumNoticeTimeBusyDays: (0, _TroubleshootingSelectors.getMinimumNoticeTimeBusyDays)(state),
    isTroubleshooting: (0, _TroubleshootingSelectors.isTroubleshootingSelector)(state),
    userTimezone: (0, _BookInfoSelectors.getUserTimezone)(state),
    isSelectedDateAvailable: (0, _AvailabilitySelectors.isSelectedDateAvailable)(state),
    selectedDate: (0, _BookInfoSelectors.getEvent)(state).dateString
  };
}), _EnsureAvailableDate.default)(DatePicker);

exports.default = _default;
module.exports = exports.default;